import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCalendarDay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path stroke="#007AFF" d="M7 .5h3v3H7zm0 12h3v3H7z" />
    <path d="M10 2h3a3 3 0 1 1 0 6H4a3 3 0 1 0 0 6h3" stroke="#007AFF" />
  </svg>
);
const Memo = memo(SvgCalendarDay);
export default Memo;
